<div class="input-btn-box border-line">
    <div class="box">
        <input 
            [type]="hideVoucher() ? 'password' : 'text'"
            autocomplete="off"
            type='text' 
            [value]="voucher()"
            (input)="voucher.set($event.target.value); hideVoucher() && hideVoucher.set(false)"
            placeholder="{{ 'VOUCHER.PLACEHOLDER' | translate }}" 
        />
        <button class="btn" 
            mat-raised-button 
            type="button" 
            (click)="applyVoucher()">
            {{ 'VOUCHER.ADD' | translate }}
        </button>
    </div>
</div>